import { useId } from 'react';
import { acquisitionLabels } from '../../data/acquisition';
import { ACQUISITION_CHANNELS, SOURCE_OTHER_MAX } from '../../core/rules/acquisition';
import { inputCls } from '../ui/styles';
import type { AcquisitionSource } from '../../core/types/insights';
type Props = {
  value: AcquisitionSource | null;
  onChange: (next: AcquisitionSource | null) => void;
};

/**
 * Aan de kassa, alleen bij een nieuwe klant: "Hoe kwam je bij ons?". Eén tik, nog eens = leeg.
 * Nooit nodig om af te rekenen.
 */
export function SaleSourceAsk({
  value,
  onChange
}: Props) {
  const id = useId();
  return <fieldset className="mt-4" data-id="element-2486" data-mp="32vaveb41nq46">
      <legend className="mb-2 text-[12px] text-muted" data-id="element-2487" data-mp="32u880d5xk5t0">
        Nieuwe klant: hoe kwam ze bij je? <span data-id="element-2488" data-mp="2yswgu37ercip">(hoeft niet)</span>
      </legend>
      <div className="flex flex-wrap gap-2" data-id="element-2489" data-mp="2ys4uzk3m4t5m">
        {ACQUISITION_CHANNELS.map(c => {
        const on = value?.channel === c;
        return <button key={c} type="button" aria-pressed={on} onClick={() => onChange(on ? null : {
          channel: c
        })} className={`whitespace-nowrap rounded-full border px-3 py-1.5 text-[13px] transition-colors duration-150 ease-soft ${on ? 'border-ink bg-ink text-shell' : 'border-line bg-white text-ink hover:border-ink/40'}`} data-id="element-2490" data-mp="3qk2i4myv7g9k">
              {acquisitionLabels[c]}
            </button>;
      })}
      </div>
      {value?.channel === 'anders' && <div className="mt-2 sm:max-w-xs" data-id="element-2491" data-mp="3l47b1wwj0dgt">
          <label htmlFor={`${id}-anders`} className="sr-only" data-id="element-2492" data-mp="3l61vla3vy3kd">
            Waar dan?
          </label>
          <input id={`${id}-anders`} value={value.other ?? ''} onChange={e => onChange({
        channel: 'anders',
        other: e.target.value.slice(0, SOURCE_OTHER_MAX)
      })} maxLength={SOURCE_OTHER_MAX} placeholder="Waar dan? (hoeft niet)" autoComplete="off" className={inputCls} data-id="element-2493" data-mp="368rad91fxjbg" />
        </div>}
    </fieldset>;
}